<p-toast [preventDuplicates]="true" [preventOpenDuplicates]="true"/>
<shared-loader [hidden]="!showLoader"/>
<p-card *ngIf="!projectSaved">
    <ng-template pTemplate="header">
                            <span class="flex align-items-center gap-2 w-full">
                                <h3 class="font-bold white-space-nowrap m-0 pl-3 pt-3 pb-0">
                                     <img class="color-image ml-auto pt-0 mr-2" [style]="{'width':'5%'}"
                                          [src]="'/assets/demo/images/logos/iconos/casa.png'">
                                    Nuevo proyecto
                                </h3>
                            </span>
    </ng-template>
    <ng-template pTemplate="content" styleClass="pt-0">
        <div *ngIf="activeIndex()==0" styleClass="pt-0">
            <p-steps [model]="stepsFU()" (activeIndexChange)="onActiveIndexChange($event)"
                     [activeIndex]="activeStep"></p-steps>
            <!--Componente por cada paso FU-->
            <ng-container *ngIf="activeStep==0">
                <generalidades-nuevo-proyecto></generalidades-nuevo-proyecto>
            </ng-container>
            <ng-container *ngIf="activeStep==1">
                <ubicacion-proyecto></ubicacion-proyecto>
            </ng-container>
            <!--TODO: Componentes que se dibujar mediante un JSON quemado desde el front-end -->
            <ng-container *ngIf="activeStep>=2">
                @for (field of fields; track field) {
                    <app-pasos-personas-proyectos *ngIf="field.step==activeStep" [fieldJson]="field" [form]="form"
                                                  [errors]="draftProjectService.errores(field.step)"></app-pasos-personas-proyectos>
                }
            </ng-container>

            <div>
                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center">
                        <p-button *ngIf="activeStep!=0" icon="pi pi-chevron-left" iconPos="right"
                                  label="Regresar"
                                  styleClass="p-button-rounded p-button-info"
                                  (click)="navigateStep(false) "></p-button>
                    </div>
                    <div class="flex align-items-center justify-content-center">
                        <p-button
                                *ngIf="activeStep!=4"
                                icon="pi pi-chevron-right" iconPos="right"
                                label="Siguiente"
                                styleClass="p-button-rounded p-button-info"
                                (click)="navigateStep(true)"></p-button>
                        <p-button *ngIf="this.banderaBotonConfirmar!=true && activeStep==4"
                                  [disabled]="showLoader||projectSaved"
                                  icon="pi pi-check" iconPos="right" pTooltip="Guardar proyecto"
                                  label="Guardar Proyecto"
                                  styleClass="p-button-rounded p-button-info"
                                  (click)="confirmarProyecto(true)"></p-button>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</p-card>
<!--dialogs-->
<p-confirmDialog #cd [style]="{ width: '50vw' }">
    <ng-template pTemplate="" let-text>
        <h4>{{ text.header }}</h4>
        <i></i>
        <p>
            {{ text.message }}
        </p>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button type="button" icon="pi pi-times" label="Cancelar"
                  styleClass="p-button-rounded p-button-danger"
                  (click)="cd.reject()"></p-button>
        <p-button type="button" icon="pi pi-check" label="Si, estoy de acuerdo"
                  styleClass="p-button-rounded p-button-info"
                  (click)="cd.accept()"></p-button>
    </ng-template>
</p-confirmDialog>
<p-dialog header="" [modal]="true" [(visible)]="progressDialog"
        closable="false"
        closeOnEscape="false"
        [style]="{ width: '40rem', maxWidth: '90vw' }"
        [breakpoints]="{ '1199px': '80vw', '575px': '95vw' }">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class="font-bold white-space-nowrap">
                    <h2>Procesando solicitud</h2>
                </span>
        </div>
    </ng-template>
    <div class="flex align-items-center gap-3 mb-3  text-4xl">
        <span class="p-text-secondary block mb-5">Guardando proyecto ...</span>
        <span class="p-text-secondary block mb-5">
                <p-progressSpinner
                        *ngIf="!projectSaved"
                        styleClass="w-2rem h-2rem"
                        strokeWidth="4"
                        fill="var(--surface-ground)"/>
                <i *ngIf="projectSaved" class="pi pi-check text-green-500  text-4xl"
                   [pTooltip]="'Proyecto se guardo correctamente'"></i>
            </span>
    </div>
    <div *ngIf="!this.draftProjectService.checkSeleted()" class="flex align-items-center gap-3 mb-3 text-4xl">
        <span class="p-text-secondary block mb-5">Guardando archivos ...</span>
        <span class="p-text-secondary block mb-5">
                <p-progressSpinner
                        *ngIf="projectSaved&&fileUtilsService.fileQueue().length>0"
                        styleClass="w-2rem h-2rem"
                        strokeWidth="4"
                        fill="var(--surface-ground)"/>
                <i *ngIf="projectSaved&&fileUploadCompleted&&fileUtilsService.fileQueue().length==0"
                   class="pi pi-check text-green-500  text-4xl" [pTooltip]="'Archivos se guardaron correctamente'"></i>
            </span>
    </div>
    <div *ngIf="!projectSaved" class="flex align-items-center gap-3 mb-3  text-4xl w-full" style="min-height: 200px;">
        <p-table
                [value]="this.draftProjectService.draftProject().tenenciaLegal"
                class="mx-auto"
                [tableStyle]="{ width: '30rem', minHeight: '150px' }"
                columnResizeMode="expand"
                styleClass="p-datatable-gridlines p-datatable-sm"
                responsiveLayout="stack">
            <ng-template pTemplate="header">
                <tr>
                    <th>Archivo</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-f let-index="rowIndex">
                <tr>
                    <td>
                        <span class="font-bold ml-1">{{ f.nombreArchivo }}</span>
                        <p-progressBar
                                *ngIf="f.hash&&this.tramite.progressBar[f.hash]<100"
                                [value]="this.tramite.progressBar[f.hash]"
                                [showValue]="true">
                        </p-progressBar>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="flex justify-content-end gap-2">
        <p-button
                [disabled]="showLoader || (!this.draftProjectService.checkSeleted() && fileUtilsService.fileQueue().length != 0)"
                [routerLink]="['/users/proyectos']"
                [queryParams]="{sessionId: sessionId}"
                queryParamsHandling="merge"
                label="Mis proyectos"
                icon="pi pi-undo text-2xl"
                styleClass="p-button-rounded mr-3 text-2xl"
                (onClick)="procesarOpcionalRq()"/>
        <p-button
                [disabled]="showLoader || (!this.draftProjectService.checkSeleted() && fileUtilsService.fileQueue().length != 0)"
                (onClick)="progressDialog = false; procesarOpcionalRq()"
                [routerLink]="['/users/tramites', selected()?.idProyecto]"
                [queryParams]="{sessionId: sessionId}"
                label="Continuar proceso"
                icon="pi pi-check text-2xl"
                styleClass="p-button-rounded p-button-success mr-3 text-2xl"/>
    </div>
</p-dialog>

<!--Dialog para re cargar los archivos que se perdieron al recargar la pagina-->
<p-dialog [(visible)]="this.draftProjectService.isReloadFile" header="Recargar los archivos" [modal]="true" class="p-fluid responsive-dialog"
          [style]="{width:'90rem', minheight:'55vh' }" [breakpoints]="{'1200px': '70vw','990px': '60vw','768px': '85vw','576px': '95vw'}"
          [draggable]="false" [resizable]="false" (onHide)="this.closeReloadFileDialog()">
    <p-messages severity="error" *ngIf="this.draftProjectService.validateFileReload()==1">
        <ng-template pTemplate>
            <div class="ml-2  text-xl">Estimado usuario, es necesario que vuelva a subir los archivos solicitados, ya que se perdieron al momento de recargar la página
            </div>
        </ng-template>
    </p-messages>
    <ng-template pTemplate="content">
        <div class="field">
            <p-table
                columnResizeMode="expand"
                [value]="this.draftProjectService.draftProject().tenenciaLegal " [paginator]="true"
                styleClass="p-datatable-gridlines p-datatable-sm" [rows]="5" [showCurrentPageReport]="true"
                responsiveLayout="stack" [tableStyle]="{ 'min-width': '50rem' }"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} personas"
                [rowsPerPageOptions]="[5, 10, 25, 50]">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:25%">Nombre</th>
                        <th style="width:25%">Número de documento</th>
                        <th style="width:25%">Archivo</th>
                        <th style="width:15%">Operación</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-personas let-index="rowIndex">
                    <tr>
                        <td>
                            <div class="text-lg font-medium text-900 mt-2">{{ personas.personaInfo.nombres }}</div>
                            <span class="font-medium text-secondary text-sm">{{ personas.tipo_propietario }}</span>
                        </td>
                        <td>
                            {{ this.personasService.findDocumentoFirst(personas.personaInfo.documentos)?.documento }}
                        </td>
                        <td>
                            <div class="flex flex-row">
                                <div class="inline-block vertical-align-middle">
                                    <i class="pi pi-upload mr-2"></i>
                                    <span class="ml-1 mt-1">{{ personas.nombreArchivo }}</span>
                                </div>
                                <div class="ml-1">
                                    <p-tag styleClass="text-xs" [severity]="personas?.pageRefresh==false?'success':'warning'" [pTooltip]="personas?.pageRefresh==false?'':'Debe volver a ingresar los archivos se perdieron cuando se recargo la pagina'"
                                           [icon]="personas?.pageRefresh==false?'pi pi-verified':'pi pi-exclamation-triangle'"/>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="flex flex-row justify-content-center">
                                <p-fileUpload [maxFileSize]="this.fileUtilsService.maxFileSize" [auto]="true" customUpload="true"
                                              #recargarArchivos id="recargarArchivos" mode="basic"
                                              chooseLabel="" chooseIcon="pi pi-upload"
                                              (uploadHandler)="onFileUpload($event,personas)"
                                              [disabled]="this.draftProjectService.checkSeleted()"
                                              name="demo[]" accept="{{this.fileUtilsService.formatoArchivo}}" class="mr-3"
                                              styleClass="p-button-icon p-button-rounded p-button-info"
                                              [pTooltip]="this.draftProjectService.checkSeleted()==true?'':'Seleccione el archivo con formato: '+this.fileUtilsService.formatoArchivo"
                                              invalidFileTypeMessageDetail="Adjuntar un archivo con un formato compatible {{this.fileUtilsService.formatoArchivo}}"
                                              invalidFileTypeMessageSummary="Formato inválido"
                                              invalidFileSizeMessageSummary="Archivo demasiado grande"
                                              invalidFileSizeMessageDetail="El archivo supera el tamaño máximo permitido de {{ this.fileUtilsService.maxFileSize / 1000000 }} MB"></p-fileUpload>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="field">
            <div class="field-checkbox" *ngIf="this.draftProjectService._validateFileReload()==1">
                <p-checkbox id="omitir" #omitirCheck="ngModel" [(ngModel)]="this.draftProjectService.checkSeleted"
                            binary="true" (onChange)="omitirCheckbox($event)" [pTooltip]="'Clic, para omitir este paso'"
                            inputId="omitir"></p-checkbox>
                <small style="color:red" class="ng-dirty ng-invalid ml-1 text-md">
                    <b>Nota: omitir este paso</b>
                </small>
            </div>
        </div>
    </ng-template>
</p-dialog>
